module.exports = "/_next/static/images/appstore-d905c7403bfa6d7d4665d10ff07e7752.webp";